module.exports = __webpack_public_path__ + "static/media/scg-icon.d8e21f6a.eot";